/**
 * Image Slider
 */

import Swiper from 'swiper';

const pageCover = {
    cfg: {

        slider: '.js-pageCover',
        sliderOptions: {
            // speed: 500,
            effect: 'fade',
            loop: true,
            autoplay: 3000,
            disableOnInteraction: false,
            // Arrows
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            on: {
                init() {
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 600);
                },
            },
        }
    },

    init() {
        const sliders = [...document.querySelectorAll(this.cfg.slider)];
        if (sliders) {
            sliders.forEach((slider) => {
                const mySwiper = new Swiper(slider, this.cfg.sliderOptions);

                mySwiper.update();

                setTimeout(() => {
                    mySwiper.update();
                }, 500);
            });
        }
    }
};

export default pageCover;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/pageCover/_script.js